function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M222.712 113.078c1.609-9.773 6.038-6.645 6.672-26.027.662-20.225-5.937-31.449-23.702-37.587C191 44.39 180.481 42.422 154.637 40.8c-25.844-1.621-39.243-2.593-56.073 3.427-15.818 5.657-22.406 16.702-23.562 29.369-1.421 15.581 3.002 20.583 3.385 30.48.35 9.068-2.355 10.861-.432 22.639 1.62 9.922 10.134 15.417 17.774 18.441 9.533 3.772 22.13 5.713 52.029 7.577 29.898 1.865 41.848.13 49.472-.381 8.032-.538 19.132-5.804 22.599-16.5 3.658-11.285 1.408-13.821 2.883-22.775z",
  fill: "#F8A6B1"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M292.095 169.727c1.31.299 2.437.154 3.382-.437 1.04-.649 1.709-1.626 2.006-2.929.263-1.149.067-2.242-.588-3.279-.56-1.096-1.495-1.793-2.804-2.092-1.309-.299-2.493-.086-3.55.641-.963.667-1.576 1.575-1.838 2.725-.298 1.303-.158 2.464.42 3.483.672.96 1.663 1.589 2.972 1.888zm-81.924-8.552l69.551 15.887 8.509-37.249-69.552-15.886-8.508 37.248zm-4.39-27.614c1.31.299 2.446.115 3.409-.552 1.04-.65 1.708-1.626 2.006-2.929.297-1.303.11-2.434-.562-3.394-.578-1.019-1.521-1.678-2.831-1.978-1.155-.263-2.291-.079-3.408.553-1.022.572-1.682 1.51-1.98 2.813-.297 1.303-.119 2.473.536 3.51.732 1.054 1.675 1.713 2.83 1.977zm4.36-19.084l7.509 1.715.231.053 74.404 16.995.231.053 7.51 1.715c2.85.651 5.01 2.193 6.48 4.625 1.565 2.374 2.024 4.978 1.376 7.814l-7.143 31.271c-.665 2.912-2.218 5.098-4.658 6.556-2.363 1.476-4.97 1.889-7.82 1.238l-7.509-1.715-.231-.053-74.404-16.995-.231-.053-7.51-1.715c-2.85-.651-5.057-2.163-6.622-4.537-1.488-2.356-1.899-4.99-1.234-7.902l7.143-31.271c.648-2.836 2.153-4.992 4.516-6.468 2.458-1.535 5.112-1.977 7.962-1.326z",
  fill: "#5E4537"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#F8A6B1",
  d: "M218.302 123.732l71.525 16.337-8.556 37.458-71.525-16.338z"
});

var _ref5 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 206.597,
  cy: 129.063,
  rx: 5.412,
  ry: 5.403,
  transform: "rotate(12.867 206.597 129.063)",
  fill: "#F5F1E3"
});

var _ref6 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 293.14,
  cy: 166.074,
  rx: 5.412,
  ry: 5.403,
  transform: "rotate(12.867 293.14 166.074)",
  fill: "#F5F1E3"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M66.817 158.017l-9.1-33.961c-.316-1.178-.99-2.065-2.022-2.662-1.032-.597-2.136-.738-3.312-.423l-24.418 6.543c-1.175.315-2.06.989-2.656 2.022-.596 1.033-.736 2.139-.42 3.316l9.1 33.961c.315 1.178.995 2.087 2.04 2.73 1.032.597 2.136.738 3.311.423l24.418-6.543c1.175-.315 2.061-.989 2.657-2.022.583-1.079.717-2.207.401-3.384zM54.825 178.92c1.221-.327 2.146-1.036 2.774-2.126.674-1.103.853-2.243.538-3.42-.316-1.178-1.04-2.075-2.176-2.693-1.09-.63-2.245-.782-3.465-.455-1.221.327-2.169 1.042-2.843 2.145-.628 1.09-.785 2.224-.47 3.402.316 1.177 1.019 2.081 2.108 2.711 1.135.618 2.313.763 3.534.436zm-30.423-59.551l26.995-7.233a10.39 10.39 0 014.22-.258c1.412.204 2.72.655 3.924 1.351a10.081 10.081 0 013.112 2.661 10.43 10.43 0 011.887 3.789l12.158 45.373a9.766 9.766 0 01.223 4.089 10.082 10.082 0 01-1.364 3.86 11.505 11.505 0 01-2.741 3.064 10.397 10.397 0 01-3.784 1.888l-26.994 7.233a10.566 10.566 0 01-4.288.275 11.788 11.788 0 01-3.839-1.301 10.09 10.09 0 01-3.111-2.66 9.776 9.776 0 01-1.852-3.654l-12.157-45.372a10.438 10.438 0 01-.26-4.226 10.09 10.09 0 011.365-3.86 11.122 11.122 0 012.655-3.114c1.12-.882 2.404-1.517 3.85-1.905z",
  fill: "#5E4537"
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  cx: 53.633,
  cy: 174.471,
  r: 4.676,
  transform: "rotate(-15 53.633 174.471)",
  fill: "#F5F1E3"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 22.962,
  y: 128.46,
  width: 35,
  height: 45,
  rx: 4,
  transform: "rotate(-15 22.962 128.46)",
  fill: "#F4DD5C"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M182.75 77.214c-4.332-4.568-14.249-14.075-25.664-18.663-.743 5.277-6.98 11.116-17.715 9.457-10.736-1.659-14.901-9.122-14.015-14.38-12.263.91-24.605 6.972-30.117 10.01a3.631 3.631 0 00-1.519 4.755c2.049 4.226 5.779 11.965 8.094 17.094a3.637 3.637 0 005.326 1.528c4.056-2.704 6.049-4.12 6.049-4.12l-8.812 20.301a8.657 8.657 0 003.136 10.646c4.393 2.919 11.759 6.383 23.456 8.194 11.71 1.813 19.784.757 24.849-.702a8.658 8.658 0 006.231-9.169l-2.208-22.425s1.43 2.2 4.452 6.082c1.387 1.783 4.057 1.888 5.573.213 3.755-4.185 9.637-10.411 12.87-13.82a3.623 3.623 0 00.014-5.001z",
  fill: "#F5F1E3"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M138.392 73.909a5.11 5.11 0 00-1.51 10.111l.057.008c2.76.396 5.351-1.506 5.778-4.276a5.11 5.11 0 00-4.268-5.835l-.057-.008zM136.178 88.204c-2.76-.396-5.351 1.506-5.778 4.276-.429 2.784 1.468 5.404 4.267 5.835l.058.008a5.11 5.11 0 101.453-10.12zM166.549 134.666l-5.533 3.48-6.682 2.039c-3.134.956-6.078-1.95-5.165-5.1l1.942-6.674 3.65-5.776c.478-1.648-.545-4.077.346-5.526a19.21 19.21 0 012.693-3.437l19.757-20.007a5.601 5.601 0 017.918-.052l9.86 9.736a5.6 5.6 0 01.052 7.917l-19.75 20.008a18.799 18.799 0 01-2.657 2.244c-1.641 1.148-4.503.559-6.431 1.148z",
  fill: "#5E4537"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M155.732 116.167c-.007.007-.007.015-.014.022a19.088 19.088 0 00-2.672 5.585l-1.898 6.534-.096.324 9.713 9.588.39-.118 6.439-1.964a18.973 18.973 0 005.401-2.635c.059-.036.11-.088.162-.125l-17.425-17.211zM40.566 40.273c.445-1.288 1.069-2.207 1.87-2.76.802-.643 1.915-.919 3.34-.827.713 0 1.515.138 2.406.414.89.184 1.87.46 2.94.828 1.157.46 2.36.965 3.607 1.517 1.247.552 2.627 1.288 4.142 2.207 1.603 1.012 2.806 2.116 3.607 3.311.891 1.196 1.07 2.483.535 3.863s-1.425 2.161-2.672 2.345c-1.426.368-2.985.368-4.677 0-3.118-.644-5.79-1.38-8.017-2.207-2.138-.828-3.83-1.702-5.077-2.621-2.316-1.656-2.984-3.679-2.004-6.07zM57.535 18.2c2.049-1.563 4.142-1.425 6.28.414 2.227 1.84 4.899 5.702 8.017 11.588.445.92.757 1.748.935 2.483.267.736.445 1.426.534 2.07.09 1.38-.445 2.529-1.603 3.448-.89.828-2.138 1.012-3.741.552a14.42 14.42 0 01-1.871-.827c-.713-.46-1.47-1.104-2.271-1.932-1.337-1.287-2.45-2.437-3.34-3.449a67.156 67.156 0 01-2.272-3.034c-1.247-1.656-2.094-3.265-2.539-4.829-.356-1.195-.4-2.437-.133-3.725.445-1.011 1.113-1.93 2.004-2.758zm24.852-9.932c2.583-.276 4.32 1.012 5.211 3.863.445 1.563.713 3.54.802 5.931.178 2.3.089 5.059-.268 8.278-.178 1.931-.579 3.494-1.202 4.69-.535 1.104-1.559 1.747-3.073 1.931-1.336.184-2.494-.367-3.474-1.655-.98-1.196-1.648-2.713-2.004-4.553-.713-3.402-1.114-6.3-1.203-8.69-.178-2.392-.044-4.277.4-5.656.446-1.564 1.07-2.622 1.872-3.173.89-.644 1.87-.966 2.939-.966z",
  fill: "#F4DD5C"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M267.154 144.153c-1.951-1.725-6.38-5.283-11.249-6.76-.115 2.202-2.473 4.833-6.956 4.538-4.483-.295-6.469-3.219-6.294-5.417-5.019.819-9.885 3.763-12.046 5.214a1.501 1.501 0 00-.453 2.014c.997 1.667 2.814 4.72 3.953 6.75a1.504 1.504 0 002.25.436 116.878 116.878 0 002.343-1.916l-2.896 8.682a3.581 3.581 0 001.678 4.273c1.915 1.044 5.075 2.204 9.96 2.527 4.89.323 8.178-.405 10.212-1.189a3.582 3.582 0 002.235-4.003l-1.722-9.159s.669.855 2.054 2.344c.636.685 1.74.631 2.304-.114 1.396-1.86 3.594-4.638 4.802-6.159a1.499 1.499 0 00-.175-2.061z",
  fill: "#F5F1E3"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M248.528 148.615a2.114 2.114 0 10.232-4.222 2.114 2.114 0 00-.232 4.222zM248.133 154.589a2.114 2.114 0 10.232-4.222 2.114 2.114 0 00-.232 4.222z",
  fill: "#5E4537"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M42.064 81.212l-1.253-5.547c-.239-1.055.389-1.58 1.372-1.17l15.621 6.34c.993.408 1.213 1.384.492 2.178l-11.38 12.431c-.722.795-1.516.58-1.752-.464l-1.102-4.877-1.998-8.89z",
  fill: "#F8A6B1"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M29.418 107.246a.97.97 0 01-1.175-.762c-2.096-11.575 4.512-23.064 17.622-26.47a.976.976 0 011.194.74l1.528 6.832c.12.539-.22 1.071-.753 1.218-8.19 2.261-11.848 8.962-10.796 15.712.085.546-.25 1.081-.79 1.202l-6.83 1.528z",
  fill: "#F8A6B1"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M262.363 99.09l5.58 1.103c1.06.209 1.286.995.513 1.728l-12.126 11.712c-.775.743-1.756.549-2.19-.432l-6.754-15.441c-.434-.982.083-1.621 1.134-1.413l4.906.968 8.937 1.776z",
  fill: "#F8A6B1"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M243.686 76.98a.97.97 0 011.173-.764c11.432 2.774 19.258 13.47 17.059 26.836a.977.977 0 01-1.16.791l-6.865-1.371c-.541-.108-.89-.636-.808-1.182 1.25-8.403-3.393-14.463-9.991-16.236-.533-.144-.886-.667-.778-1.209l1.37-6.864z",
  fill: "#F8A6B1"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M51.025 132.91a1.567 1.567 0 011.915 1.105l4.097 15.291a1.568 1.568 0 01-1.105 1.915l-15.29 4.097a1.568 1.568 0 01-1.916-1.106l-4.097-15.29a1.568 1.568 0 011.106-1.915l15.29-4.097zm-.922-3.44l-15.29 4.097a5.125 5.125 0 00-3.624 6.277l4.097 15.29a5.125 5.125 0 006.277 3.624l15.29-4.097a5.126 5.126 0 003.624-6.277l-4.097-15.29a5.128 5.128 0 00-6.277-3.624z",
  fill: "#5E4537"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M40.506 141.015l.025.092-.092.025-.025-.092.092-.025zm1.457-4.078l-4.85 1.299a1.1 1.1 0 00-.777 1.347l1.3 4.849a1.1 1.1 0 001.346.778l4.85-1.3a1.1 1.1 0 00.777-1.346l-1.3-4.849a1.1 1.1 0 00-1.346-.778z",
  fill: "#5E4537"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M42.97 142.652l-3.861 1.034a.176.176 0 01-.217-.125l-1.035-3.86a.177.177 0 01.126-.217l3.86-1.034a.176.176 0 01.217.125l1.034 3.86a.18.18 0 01-.125.217z",
  fill: "#F4DD5C"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M41.4 141.988l-1.274.341a.46.46 0 01-.568-.328l-.342-1.274a.46.46 0 01.328-.568l1.275-.342a.461.461 0 01.568.328l.341 1.275a.464.464 0 01-.328.568zM43.952 146.985l-3.533.947.947 3.532 3.533-.946-.947-3.533z",
  fill: "#5E4537"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M42.691 149.17l.025.092-.092.025-.025-.093.092-.024zm1.457-4.078l-4.85 1.299a1.1 1.1 0 00-.777 1.347l1.3 4.849a1.1 1.1 0 001.346.777l4.85-1.299a1.1 1.1 0 00.777-1.347l-1.3-4.849a1.1 1.1 0 00-1.346-.777z",
  fill: "#5E4537"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M45.154 150.807l-3.86 1.035a.177.177 0 01-.217-.125l-1.035-3.861a.177.177 0 01.126-.217l3.86-1.034a.177.177 0 01.217.125l1.034 3.861a.18.18 0 01-.125.216z",
  fill: "#F4DD5C"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M43.585 150.143l-1.274.342a.462.462 0 01-.568-.328l-.342-1.275a.461.461 0 01.328-.568l1.275-.341a.46.46 0 01.568.327l.341 1.275a.464.464 0 01-.328.568z",
  fill: "#5E4537"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M43.004 147.973l-1.275.341a.461.461 0 00-.328.568l.342 1.275a.462.462 0 00.568.328l1.274-.342a.461.461 0 00.328-.568l-.341-1.275a.46.46 0 00-.568-.327zM48.758 138.804l.025.092-.092.025-.025-.093.093-.024zm1.461-4.079l-4.848 1.299a1.1 1.1 0 00-.778 1.347l1.3 4.849a1.1 1.1 0 001.346.777l4.849-1.299a1.1 1.1 0 00.777-1.347l-1.299-4.849a1.106 1.106 0 00-1.347-.777z",
  fill: "#5E4537"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M51.221 140.441l-3.86 1.034a.177.177 0 01-.217-.125l-1.034-3.861a.175.175 0 01.125-.216l3.86-1.035a.177.177 0 01.217.125l1.035 3.861a.18.18 0 01-.126.217z",
  fill: "#F4DD5C"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M49.653 139.776l-1.275.342a.461.461 0 01-.568-.328l-.341-1.275a.461.461 0 01.328-.568l1.274-.341a.46.46 0 01.568.328l.342 1.274a.464.464 0 01-.328.568zM48.235 143.997l-1.741.467.466 1.741 1.741-.467-.466-1.741z",
  fill: "#5E4537"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M48.235 143.997l-1.741.467.466 1.741 1.741-.467-.466-1.741zM49.16 147.451l-1.74.467.466 1.741 1.74-.467-.466-1.741zM51.368 148.727l-1.741.466.466 1.741 1.741-.466-.466-1.741z",
  fill: "#5E4537"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M51.368 148.727l-1.741.466.466 1.741 1.741-.466-.466-1.741zM51.721 143.063l-1.745.468.466 1.741 1.746-.468-.467-1.741zM50.442 145.272l-1.74.466.466 1.741 1.74-.466-.466-1.741zM53.929 144.338l-1.741.467.466 1.741 1.741-.467-.466-1.741zM52.651 146.552l-1.74.466.466 1.741 1.74-.466-.466-1.741zM54.863 147.825l-1.74.466.466 1.741 1.74-.466-.466-1.741z",
  fill: "#5E4537"
});

var SvgImgImageMydesign = function SvgImgImageMydesign(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 320 200",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgImgImageMydesign, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/img_image_mydesign.891da09f.svg";
export { ForwardRef as ReactComponent };